import { handleActions, createAction } from "redux-actions";
import { api } from "../../../services";
import { PhoneVerificationRequestStatus } from "../../../models";

const PHONE_VERIFICATION_REQUESTS_GET = "PHONE_VERIFICATION_REQUESTS_GET";
const PHONE_VERIFICATION_REQUEST_UPDATE = "PHONE_VERIFICATION_REQUEST_UPDATE";

export const getPhoneVerificationRequests = createAction(
  PHONE_VERIFICATION_REQUESTS_GET,
  async (filters, page, itemPerPage) => {
    try {
      const result = await api.Phone.phoneVerificationRequestList({
        ...filters,
        page,
        itemPerPage
      });

      return {
        page,
        itemPerPage,
        requests: result.data,
        total: result.count
      };
    } catch (e) {
      
      return { requests: [] };
    }
  }
);

export const updatePhoneVerificationRequest = createAction(
  PHONE_VERIFICATION_REQUEST_UPDATE,
  async (id, data, requests, callback) => {
    try {
      await api.Phone.phoneVerificationRequestUpdate(id, data);

      const updatedRequests = requests.map(request => {
        if (request.id === id) {
          return {
            ...request,
            ...data
          };
        }

        return request;
      });

      callback && callback();

      // filter out the ones with PhoneVerificationRequestStatus.verified
      const filteredRequests = updatedRequests.filter(
        request => request.verificationRequestStatus !== PhoneVerificationRequestStatus.verified
      );

      return { requests: filteredRequests };
    } catch (e) {
      callback && callback();

      return null;
    }
  }
);

const defaultState = {
  page: 1,
  itemPerPage: 10,
  total: 0,
  requests: [],
  filters: {}
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload
});

export default handleActions(
  {
    [PHONE_VERIFICATION_REQUESTS_GET]: updateState,
    [PHONE_VERIFICATION_REQUEST_UPDATE]: updateState,
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManagePhoneVerificationPage/phoneVerification.ducks.ts